 
import http from "@/http/service"
 
export default function DeletarParceiro(idParceiro=0){

    return http.delete(`/admin/parceiro/${idParceiro}`)

}